export default "__VITE_ASSET__5a3e7f47__"